import './solutionPremiumRoutes.styles';
import React from 'react';
import PatientsHeroSection from '../components/hero/PatientsHeroSection';
import SolutionPageLayout from '../components/premium/SolutionPageLayout';
import { solutionPatientsConfig } from '../data/solutionContent';

const SolutionPatients: React.FC = () => (
  <SolutionPageLayout hero={<PatientsHeroSection />} config={solutionPatientsConfig} />
);

export default SolutionPatients;
